const moment = require('moment-timezone');

/**
 * Validates if the end time is after start time.
 * Used in form validations with Yup.
 *
 * @param {any} value - The end time value being validated
 * @param {object} context - The Yup validation context
 * @returns {boolean} - True if end time is after start time
 */
function validateEndTimeAfterStartTime(value, context) {
  const startDay = moment(context.parent.startDate).startOf('day');
  const startTime = moment(context.parent.startTime);
  const startDateTime = startDay.clone();
  startDateTime.hour(startTime.hour()).minute(startTime.minute());

  // If endDate is not provided (e.g., indefinite recurrence or one time food run),
  // use the same day as startDate for computing endDateTime.
  // the one time food run create form doesn't have an end date input, so we need to handle that as well
  const hasNoEndDate =
    context?.parent?.occurrenceType === 'indefinite' ||
    (context.parent.is_food_run &&
      context?.parent?.occurrenceType === 'onetime');
  const endDay =
    !hasNoEndDate && context?.parent?.endDate
      ? moment(context.parent.endDate).startOf('day')
      : startDay.clone();
  const endTime = moment(value);
  const endDateTime = endDay.clone();
  endDateTime.hour(endTime.hour()).minute(endTime.minute());
  //  the endDate should be incremented by 1 day if endTime is before startTime
  if (hasNoEndDate && endDateTime.isBefore(startDateTime)) {
    endDateTime.add(1, 'days');
  }
  return endDateTime.isSameOrAfter(startDateTime);
}

module.exports = { validateEndTimeAfterStartTime };
